module.exports = __webpack_public_path__ + "static/media/matilde-special-crown-scary.9b5de051.png";